import React from "react";
import { Chip, ChipProps } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  parent: {
    "& .MuiChip-label": {
      // vertically alignment fix working in Firefox, Chrome, Safari
      // this only works for "normal" chips (with 32px size) and needed with font-family "Proxima Nova"
      borderTop: "0.03125rem solid transparent",
      lineHeight: 1.5,
    },
  },
});

const VerticalAlignedChip = (props: ChipProps) => {
  const classes = useStyles(props);
  const { className, ...attrs } = props;
  return <Chip {...attrs} className={`${className || ""} ${classes.parent}`} />;
};

export default VerticalAlignedChip;
